import React, { useState, useRef, useEffect } from 'react';
import { HiMenu } from 'react-icons/hi';
import { AiFillCloseCircle } from 'react-icons/ai';
import { Link, Route, Routes } from 'react-router-dom';

import { SideBar, UserProfile, Pins } from '../../components';
import { client } from "../../client";
import logo from '../../assets/logo.png';
import {HOME, USER_PROFILE} from "../../constants/routes";

import { userQuery } from '../../utils/data';

import {homeStyle} from "../../styles/homeStyle";

const ROUTE = 'user-profile/';
const fontSizes = {
    forty: 40,
    thirty: 30,
};

const Home = () => {

    const [user, setUser] = useState(null);
    const [ioOpenSideBar, setSideBar] = useState(false);

    const scrollRef = useRef(null);
    const userInfo = localStorage.getItem('user') !== 'undefined' ? JSON.parse(localStorage.getItem('user'))
        : localStorage.clear();

    useEffect(() => {
        const query = userQuery(userInfo?.googleId);

        client.fetch(query)
            .then((data) => {
                setUser(data[0]);
            })
            .catch(error => console.error(error));
    }, [userInfo?.googleId]);

    useEffect(() => {
        scrollRef.current.scrollTo(0, 0);
    }, []);

    const setToggleSideBar = (value) => setSideBar(value);

    return (
        <div className={homeStyle.home}>
            <div className={homeStyle.sideBar}>
                <SideBar user={user && user} />
            </div>
            <div className={homeStyle.hiMenuContainer}>
                <div className={homeStyle.menu}>
                    <HiMenu fontSize={fontSizes.forty}
                            className={homeStyle.hiMenu}
                            onClick={setToggleSideBar.bind(this, true)} />
                    <Link to={HOME}>
                        <img src={logo} alt="logo" className={homeStyle.homeLogo} />
                    </Link>
                    <Link to={`${ROUTE}${user?._id}`}>
                        <img src={user?.image} alt="userImage" className={homeStyle.homeLogo} />
                    </Link>
                </div>
                {ioOpenSideBar && (
                    <div className={homeStyle.sideBarContainer}>
                        <div className={homeStyle.sideBarContent}>
                            <AiFillCloseCircle fontSize={fontSizes.thirty}
                                               className="cursor-pointer"
                                               onClick={setToggleSideBar.bind(this, false)} />
                        </div>
                        <SideBar user={user && user} closeToggle={setToggleSideBar} />
                    </div>
                )}
            </div>
            <div className={homeStyle.routeContainer} ref={scrollRef}>
                <Routes>
                    <Route path={USER_PROFILE} element={<UserProfile />} />
                    <Route path={HOME} element={<Pins user={user && user} />} />
                </Routes>
            </div>
        </div>
    );
};

export default Home;
